// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1rAjX","label":"CategoryService_label__ySKUS","location":"CategoryService_location__3AXDM"};